import type { LucideIcon } from 'lucide-react'
import { TrendingDown, TrendingUp } from 'lucide-react'

interface KpiCardProps {
  title: string
  value: string
  change: string
  trend: string
  icon: LucideIcon
  color: string
  bgColor: string
}

export function KpiCard({
  title,
  value,
  change,
  trend,
  icon: Icon,
  color,
  bgColor,
}: KpiCardProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-card-foreground/70">
            {title}
          </p>

          <p className="mt-2 text-2xl font-semibold text-card-foreground">
            {value}
          </p>

          <div className="mt-2 flex items-center gap-1">
            {trend === 'up' ? (
              <TrendingUp className="h-4 w-4 text-green-600" />
            ) : (
              <TrendingDown className="h-4 w-4 text-red-600" />
            )}

            <span
              className={`text-sm ${
                trend === 'up'
                  ? 'text-green-600'
                  : 'text-red-600'
              }`}
            >
              {change}
            </span>

            <span className="ml-1 text-xs text-card-foreground/70">
              vs ayer
            </span>
          </div>
        </div>

        <div className={`rounded-lg p-3 ${bgColor}`}>
          <Icon className={`h-6 w-6 ${color}`} />
        </div>
      </div>
    </div>
  )
}